import React from "react";

import NotificationsList from "notifications/components/NotificationsList";
import { useAppDispatch, useAppSelector } from "store";
import { notificationsViewSet, openedNotificationSet, selectAllNotifications, selectNewNotifications, selectNotificationsView, selectOpenedNotification } from "slices/notificationsSlice";

const NotificationsDashboard = () => {
  const dispatch = useAppDispatch();

  const allNotifications = useAppSelector(selectAllNotifications);
  const newNotifications = useAppSelector(selectNewNotifications);
  const currentView = useAppSelector(selectNotificationsView);
  const openedNotification = useAppSelector(selectOpenedNotification);

  if (!currentView && !openedNotification) {
    return null;
  }

  const handleOpenNotification = (notify) => {
    dispatch(openedNotificationSet(notify));
  };

  const handleClose = () => {
    dispatch(notificationsViewSet(""));
  };

  const handleSetViewNew = () => {
    if (currentView !== "new") {
      dispatch(notificationsViewSet("new"));
    }
  };

  const handleSetViewAll = () => {
    if (currentView !== "all") {
      dispatch(notificationsViewSet("all"));
    }
  };

  return (
    <NotificationsList
      onSetViewAll={handleSetViewAll}
      onSetViewNew={handleSetViewNew}
      onClose={handleClose}
      allNotifications={allNotifications}
      newNotifications={newNotifications}
      currentView={currentView}
      openedNotification={openedNotification}
      onOpenNotification={handleOpenNotification}
    />
  );
};

export default NotificationsDashboard;
